import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

interface LogoProps {
  isScrolled?: boolean;
}

const Logo = ({ isScrolled }: LogoProps) => {
  return (
    <Link to="/" className="flex items-center z-10 group">
      <div className="flex items-center gap-2.5">
        <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-secondary to-primary flex items-center justify-center shadow-md ring-1 ring-accent/40">
          <span className="text-accent font-heading font-bold text-base leading-none">L</span>
        </div>
        <div className="leading-tight">
          <div
            className={cn(
              "font-heading font-bold text-base tracking-tight",
              isScrolled ? "text-foreground" : "text-primary-foreground"
            )}
          >
            LA SEO <span className="gold-gradient-text">Services</span>
          </div>
          <div
            className={cn(
              "text-[10px] uppercase tracking-[0.15em] font-medium",
              isScrolled ? "text-muted-foreground" : "text-accent/90"
            )}
          >
            Culver City
          </div>
        </div>
      </div>
    </Link>
  );
};

export default Logo;
